var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowThinOrange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20.0 20.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.936,0.29325 C10.327,-0.09775 10.96,-0.09775 11.351,0.29325 L19.707,8.65025 C20.098,9.04125 20.098,9.67325 19.707,10.06425 L11.351,18.42125 C11.155,18.61625 10.899,18.71325 10.644,18.71325 C10.388,18.71325 10.132,18.61625 9.936,18.42125 C9.546,18.03025 9.546,17.39725 9.936,17.00625 L16.657,10.28625 L1,10.28625 C0.447,10.28625 0,9.83825 0,9.28625 C0,8.73325 0.447,8.28625 1,8.28625 L16.515,8.28625 L9.936,1.70725 C9.546,1.31625 9.546,0.68325 9.936,0.29325 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 1.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,-8.8817842e-16 20.00025,-8.8817842e-16 20.00025,18.71325 0,18.71325 0,-8.8817842e-16",
    stroke: "none",
    fill: "#FF7800"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowThinOrange);
export default __webpack_public_path__ + "static/media/arrow_thin_orange.417c7ed6d7578b271f5a04a86b7fbe62.svg";
export { ForwardRef as ReactComponent };